const cookieUtil = {
  get(name) {
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=')
      if (arr2[0] == name) {
        return arr2[1]
      }
    }
    return ''
  },
  set(name, value, iDay) {
    var oDate = new Date()
    oDate.setDate(oDate.getDate() + iDay)
    document.cookie = name + '=' + value + ';expires=' + oDate
  },
  remove(name) {
    this.set(name,'')
  }
}

export default cookieUtil



// WEBPACK FOOTER //
// ./src/utils/cookieUtil.js